import React from 'react'
import axios from 'axios'
import Header from '../Header/Header';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import 'moment/locale/nl';
import { url } from '../../utils/const';
import { connect } from "react-redux";

import { logout } from "../../actions/AuthActions";
import { fetchMendixUser } from "../../actions/UserActions";

// -------------------------------------------------
// Helpers: groepeer alleen als aaneengesloten
// (vrijdag -> maandag telt ook als aaneengesloten)
// -------------------------------------------------
function toDateOnly(d) {
    const dt = new Date(d);
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}

function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

function datesAreEqual(a, b) {
    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    );
}

function isAaneengesloten(prevUntil, nextFrom) {
    // Normaal: volgende kalenderdag
    const nextDay = addDays(prevUntil, 1);
    if (datesAreEqual(nextDay, nextFrom)) return true;

    // Speciaal: vrijdag -> maandag (weekend ertussen)
    const prevDow = prevUntil.getDay(); // vrijdag = 5
    const nextDow = nextFrom.getDay();  // maandag = 1

    if (prevDow === 5 && nextDow === 1) {
        const monday = addDays(prevUntil, 3);
        if (datesAreEqual(monday, nextFrom)) return true;
    }

    return false;
}

function toNumber(val) {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const parsed = parseFloat(String(val).replace(",", "."));
    return isNaN(parsed) ? 0 : parsed;
}

function minDateString(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a < b ? a : b;
}

function maxDateString(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a > b ? a : b;
}

function groupHolidaysAaneengesloten(raw) {
    const items = Array.isArray(raw) ? raw.slice() : [];

    // sorteer op startdatum
    items.sort((a, b) => {
        const da = toDateOnly(a.fromDate).getTime();
        const db = toDateOnly(b.fromDate).getTime();
        return da - db;
    });

    const groups = [];
    let current = null;

    for (let i = 0; i < items.length; i++) {
        const h = items[i];
        if (!h || !h.fromDate || !h.untilDate) continue;

        const from = toDateOnly(h.fromDate);
        const state = h.state;

        if (!current) {
            current = {
                requestedAt: h.requestedAt,
                evaluatedAt: h.evaluatedAt,
                state: state,
                fromDate: h.fromDate,
                untilDate: h.untilDate,
                offTime: toNumber(h.offTime)
            };
            continue;
        }

        const currentUntil = toDateOnly(current.untilDate);
        const sameState = current.state === state;
        const aansluitend = isAaneengesloten(currentUntil, from);

        if (sameState && aansluitend) {
            // verleng de range
            current.untilDate = h.untilDate;

            // tel dagen op
            current.offTime = toNumber(current.offTime) + toNumber(h.offTime);

            // requestedAt: neem de vroegste binnen de reeks
            current.requestedAt = minDateString(current.requestedAt, h.requestedAt);

            // evaluatedAt: neem de laatste binnen de reeks
            current.evaluatedAt = maxDateString(current.evaluatedAt, h.evaluatedAt);
        } else {
            groups.push(current);
            current = {
                requestedAt: h.requestedAt,
                evaluatedAt: h.evaluatedAt,
                state: state,
                fromDate: h.fromDate,
                untilDate: h.untilDate,
                offTime: toNumber(h.offTime)
            };
        }
    }

    if (current) groups.push(current);

    return groups;
}

class Holiday extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {

        // ✅ eerst Mendix-user ophalen zodat email zeker bestaat
        await this.props.fetchMendixUser();

        const user = this.props.user;
        if (!user || !user.email) {
            console.error("❌ Mendix-user of email ontbreekt");
            return;
        }

        // Haal vakantie-aanvragen op
        axios.get(
            url + `/api/v1/proxy/mendix/my-holidays`
        ).then(res => {
            this.setState({
                // ✅ groepeer alleen aaneengesloten (vrijdag->maandag telt ook)
                holidays: groupHolidaysAaneengesloten(res.data.holidays),
                remainingDaysOf: res.data.numberOfDaysOff != null ? res.data.numberOfDaysOff : 0,
                pendingDays: res.data.numberOfDaysPending != null ? res.data.numberOfDaysPending : 0
            });
        });
    }

    render() {

        moment.updateLocale('nl', {});

        let holidays = null;
        const states = {
            "PENDING": "Afwachtend",
            "ACCEPTED": "Geaccepteerd",
            "DISCARDED": "Afgewezen",
            "INVOICED": "Gefactureerd"
        };

        if (this.state.holidays != null) {
            holidays = this.state.holidays.map((holiday, index) => {
                let evaluatedAt = holiday.evaluatedAt
                    ? moment(holiday.evaluatedAt).format("DD-MM-YYYY")
                    : null;

                // ✅ unieke key (requestedAt is vaak niet uniek genoeg)
                const key =
                    String(holiday.requestedAt || "") + "|" +
                    String(holiday.fromDate || "") + "|" +
                    String(holiday.untilDate || "") + "|" +
                    String(holiday.state || "") + "|" +
                    String(index);

                return (
                    <tr key={key}>
                        <td>{holiday.requestedAt ? moment(holiday.requestedAt).format("DD-MM-YYYY") : ""}</td>
                        <td>{moment(holiday.fromDate).format("DD-MM-YYYY")}</td>
                        <td>{moment(holiday.untilDate).format("DD-MM-YYYY")}</td>
                        <td>{holiday.offTime}</td>
                        <td>{states[holiday.state] || holiday.state}</td>
                        <td>{evaluatedAt}</td>
                    </tr>
                );
            });
        }

        return (
            <div>

                <Header
                    location={this.props.location}
                    toggleAllHolidays={this.props.toggleAllHolidays}
                    showAllHolidays={false}    // Mijn vakanties = altijd false
                    user={this.props.user}     // ⭐ Mendix-user → voor Menu, beheer, etc.
                />

                <main className="main-content m-t-xs responsive-form">
                    <div className="container">

                        <div className="card small-padding m-t-42">
                            <h2 className="h1 m-t-sm m-b-sm">Mijn vakanties</h2>

                            Beschikbaar: {this.props.user && this.props.user.RestAantalVakantieDagen} <br />
                            Aangevraagd: {this.props.user && this.props.user.AangevraagdeVakantieDagen}

                            <h3 className="m-t-sm">Hoe vraag ik vakantie aan?</h3>
                            Op de homepagina boek je de uren op het vakantieproject. <br />
                            Zodra de leidinggevende de aanvraag heeft goed-/afgekeurd, krijg je een e-mail.

                            <div className="clearFix" />

                            <div className="has-wide-table m-t-sm">
                                <table className="full-width wide-table table">
                                    <thead>
                                        <tr>
                                            <th>Aangevraagd op</th>
                                            <th>Van</th>
                                            <th>Tot</th>
                                            <th>Aantal dagen</th>
                                            <th>Status</th>
                                            <th>Beoordeeld op</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {holidays}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </div>
                </main>
            </div>
        );
    }
}

/* ⭐ Haal Mendix-user uit Redux (niet auth-user!) */
function mapStateToProps(state) {
    return {
        user: state.user.mendixUser
    };
}

/* ⭐ Gebruik fetchMendixUser en logout */
export default connect(
    mapStateToProps,
    { fetchMendixUser, logout }
)(Holiday);
